/**
 * 工期（開始日・終了日）解決ロジック
 *
 * 工期表示は管理画面（frontend-admin の SiteList）と完全に一致させる。
 * 管理画面は現場マスタ（/site/search の SiteDto）の計画工期
 * plannedStartDate/plannedEndDate を工期として表示している。
 * 通常画面（frontend-user の DiaryList / MetaDataSite）でも同じ値を表示するため、
 * site_meta は参照せず、現場マスタの計画工期を正とする。
 *
 * バックエンド（/site/search の SiteDto）の workPeriod は「工期（月数）」を表す
 * 数値であり、{ startDate, endDate } オブジェクトではない点に注意。
 * そのため現場の工期日付は plannedStartDate/plannedEndDate（無ければ startDate/endDate）
 * から取得する。
 */

/**
 * 工期の開始日・終了日を解決する純粋関数。
 *
 * 優先順位（管理画面 SiteList と一致）:
 *   1. 現場の計画工期 plannedStartDate / plannedEndDate
 *   2. 現場の実工期 startDate / endDate（計画工期未設定時のフォールバック）
 *
 * site_meta は工期表示には用いない（管理画面と食い違うため）。
 *
 * @param {Object} [site] 選択中の現場（/site/search のレスポンス要素）
 * @returns {{ start: string, end: string }} 解決された工期の開始日・終了日
 */
export function resolveWorkPeriodDates(site) {
  const s = site || {};
  return {
    start: s.plannedStartDate || s.startDate || "",
    end: s.plannedEndDate || s.endDate || "",
  };
}

export default { resolveWorkPeriodDates };
